

import config from '@/config/index'
import lawtopBanner from '@/assets/lawyer/banner-law.png'
import { getLawyerDetail } from '@/api/lawyer'
export default {
name: 'lawyer',
components: {},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
lawtopBanner: lawtopBanner,
list: {},
lawid: this.$route.params.id,
goodlist: [],
select: 2
}
},
created () {
this.getlist()
},
mounted () {


},
methods: {
getlist () {
getLawyerDetail({
id: this.lawid
}).then(res => {
this.list = res.returnValue
this.goodlist = res.returnValue.goodfields.split(';')
})
},
gosub () {
this.$router.push({ name: 'lawyerSubmit', params: { id: this.lawid } })
}
}
}
